import { useEffect, useLayoutEffect, useRef } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import Banner from 'src/components/common/Banner';
import Footer from 'src/components/common/Footer';
import JoinCertification from 'src/components/join/JoinCertification';
import Notification from 'src/components/join/Notification';
import { useTermsQuery } from 'src/hooks/queries/useTermsQuery';
import { PartnerState, TermsListState } from 'src/recoil/ui';
import styled from 'styled-components';

import { useParams } from 'react-router-dom';
import MvnoModal from 'src/components/join/MvnoModal';
import { useCheckTelecomIsBlock } from 'src/hooks/useCheckTelecomIsBlock';
import { useSubmit } from 'src/hooks/useSubmit';
import { PCodeState, RequestIdState } from 'src/recoil/common';
import { EventFooter } from 'src/types/type';
import { openNewTab } from 'src/utils/Router';
import {useTrackingPage} from "src/hooks/useTrackingPage";
import {landing_greenp} from "src/utils/greenp";
import VulnerableCheckModal from 'src/components/join/VulnerableCheckModal';

const DefaultFooter = (
  <>
      <li className="important">본 서비스는 청약철회가 불가능한 상품입니다.</li>
      <li className="important">서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.</li>
      <li>휴대폰도난결제 보상 보험은 가입 다음날 0시부터 제공되며, 자기부담금 20만원(1회 사고당)이 발생합니다. 해당 보험은 1인 1사고당 보험한도액 100만원 내 보상하며, 증권상 최대 보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
      <li>본 서비스는 스마트폰 사용자만 이용가능합니다. 본 서비스는 앱을 설치하셔야만 서비스를 이용하실 수 있습니다.</li>
      <li>
        안드로이드 7.0 이상을 지원하지 않는 단말기 및 피처폰, 아이폰 고객은 서비스 이용이 불가합니다.
      </li>
      <li>본 서비스는 ㈜데이터유니버스가 운영합니다. 고객센터 1811-4031(이용, 해지문의)</li>
      <li>
        홈페이지 주소 :
        <p onClick={() => openNewTab('https://www.mfinder.co.kr')} style={{display: "inline"}}>https://www.mfinder.co.kr</p>
      </li>
      <li>전화번호 : 1811-4031, 이메일 : cs@datau.co.kr</li>
  </>
);

const MegaCoffeeFooter = (
  <>
    <li className="important">본 이벤트 및 휴대폰분실보호 서비스는 (주)데이터유니버스에서 제공합니다.</li>
    <li className="important">본 서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.</li>
    <li>본 서비스의 원활한 이용을 위해 앱을 설치해주세요.</li>
    <li>본 서비스는 청약철회가 불가능한 상품입니다.(전자상거래 등에서의 소비자보호에 관한 법률 제17조 2항 5호에 따라 디지털 콘텐츠의 제공이 개시된 경우 청약철회를 제공하지 않습니다.)</li>
    <li>본 이벤트는 만 20세 이상이 아니거나, 휴대폰 정지 혹은 이용중인 스마트폰 OS에 따라 참여에 제한이 있을 수 있습니다.</li>
    <li>본 이벤트의 경품의 경우, 휴대폰분실보호 서비스에 유료로 신규 가입한 고객에 한하여 지급됩니다.</li>
    <li>본 이벤트는 경품 추첨일 이전에 서비스를 해지하시는 경우 경품이 지급되지 않습니다.</li>
    <li>본 이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용기한이 만료된 경우 보상하지 않습니다.</li>
    <li>본 이벤트의 경품인 메가커피 아메리카노 모바일 쿠폰의 경우, 신규 가입 후 24시간 이내 유지자 전원에게 휴대폰 번호로 문자 발송되며 운영사의 사정에 따라 지연될 수 있습니다.</li>
    <li>본 이벤트에 비정상적, 불법적인 방법으로 참여한 경우, 당첨자 선정에서 제외되거나 당첨이 취소될 수 있습니다.</li>
    <li>본 이벤트는 운영사의 사정에 따라 별도 고지없이 변경 또는 중단될 수 있습니다.</li>
    <li>본 이벤트는 휴대폰번호 기준 1회만 참여 가능합니다.</li>
    <li>문의 : 고객센터 1811-4031, 이메일 : cs@datau.co.kr</li>
    <li>
      서비스 홈페이지 :
      <p onClick={() => openNewTab('https://www.mfinder.co.kr')} style={{display: "inline"}}>https://www.mfinder.co.kr</p>
    </li>
  </>
);

const MainContainer = styled.div<{backgroundColor: string}>`
  background-color: ${props => props.backgroundColor};
  overflow: hidden;  //Margin Collapsing 방지용 코드
`;

const FooterList: EventFooter[] = [
  {
  name: "MegaCoffee",
  BtmMsg: MegaCoffeeFooter,
  EventPCode: "mkt_mf_ka_4_9_",
}];

let EleFooter = DefaultFooter

const Mkt01 = () => {
  const { pcode, requestID } = useParams();
  const [partner, setPartner] = useRecoilState(PartnerState);
  const setPCode = useSetRecoilState(PCodeState);
  const setRequestIdState = useSetRecoilState(RequestIdState);
  const setTermsList = useSetRecoilState(TermsListState);
  const { form, isGreenpTracking } = useTrackingPage()

  //Greenp 추적 스크립트 추가(251217)
  useEffect(() => {
    if (!isGreenpTracking) return
    if ((window as any).__GREENP_LANDING_INIT__) return
      ;(window as any).__GREENP_LANDING_INIT__ = true
    landing_greenp()
  }, [form, isGreenpTracking])

  const getTermsData = useTermsQuery(`${requestID}`, { PCode: pcode });

  useCheckTelecomIsBlock()

  const subImageRef = useRef<HTMLImageElement>(null);
  const submit = useSubmit()
  useEffect(() => {
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = "auto";
    }
  }, []);

  useLayoutEffect(() => {
    if (window.location.host.indexOf("dev") >= 0) {
      alert("개발기에서는 통신사를 잘못 지정해도 문자 발송 및 가입 됩니다. ")
    }
  }, []);

  useEffect(() => {
    if (pcode === undefined || requestID === undefined) {
      return
    }

    setRequestIdState(requestID);
    setPCode(pcode);

    let slicePcode = pcode.slice(0, pcode.lastIndexOf("_"));
    let evt = FooterList.filter((ev) => ev.EventPCode.includes(slicePcode))[0];
    if (evt !== undefined) {
      EleFooter = evt.BtmMsg;
    }
  }, [pcode, requestID, setPCode, setRequestIdState]);

  useEffect(() => {
    const terms = getTermsData.data;
    if (!!terms) {
      !!terms.Terms && setTermsList(terms.Terms);
      !!terms.Partner && setPartner(terms.Partner);
    }
  }, [getTermsData, setPartner, setTermsList]);

  const scrollToInputArea = () => {
    subImageRef.current?.scrollIntoView({ behavior: 'auto' });
  }

  return (
    <>
      <Banner img={partner.Image1} />
      <Banner img={partner.Image2} ref={subImageRef} />
      <MainContainer backgroundColor={partner.UiData.layoutsInsert.mainBg as string}>
        <JoinCertification handleFocus={scrollToInputArea} submit={submit} />
        <Notification
          text={partner.NotiContent}
          styles={{ fontSize: partner.FontSize, fontColor: partner.FontColor, cashSpace: partner.UiData.layoutsVerify.cashSpace }}
        />

        <Footer styles={partner.UiData.layoutsFooter}>{EleFooter}</Footer>
      </MainContainer>
      <MvnoModal submit={submit}/>
      <VulnerableCheckModal submit={submit}/>
    </>
  );
};

export default Mkt01;
